<template>
  <b-container fluid style="min-height: calc(100vh - 200px)" class="px-0">
    <b-row class="h-100">
      <div class="col-md-5 mb-3 h-100">
        <b-card class="d-flex h-100">
          <div class="d-flex align-items-center p-1">
            <b-form-input type="text"
                      :placeholder="$lang.Common.Buttons.Search + '...'"
                      v-model="searchField"
                      @input="onSearchFieldChanged"/>
            <i class="fas fa-times ml-1" v-if="searchField" @click="onClearSearch" style="cursor:pointer;"></i>
          </div>
          <div class="d-flex">
            <div class="d-flex col-6">
              <b-checkbox switch class="m-1" v-model="showRevised" @change="processList">{{$lang.PCI.Lpu.LabelShowRevised}}</b-checkbox>
              <b-checkbox switch class="m-1" v-model="showExcluded" @change="processList">{{$lang.PCI.Lpu.LabelShowExcluded}}</b-checkbox>
            </div>
            <div class="d-flex col-6 justify-content-end">
              <b-button rounded
                        no-caret
                        variant="link"
                        class="p-0 m-1"
                        :disabled="!rowSelected"
                        @click="onSelect"
                        tabindex="-1">
                <i class="fas fa-pen text-third"></i>
              </b-button>
              <b-dropdown href="#"
                          variant="link"
                          toggle-class="text-decoration-none p-0 m-1"
                          no-caret
                          :disabled="!rowSelected || rowSelected.status !== 1"
                          tabindex="-1">
                <template #button-content>
                  <i class="fa fa-trash text-danger p-1"
                    style="cursor:pointer">
                  </i>
                </template>
                <b-dropdown-header><strong>{{$lang.Common.ConfirmDelete}}</strong></b-dropdown-header>
                <b-dropdown-item href="#" v-on:click="onDelete">{{$lang.Common.Yes}}</b-dropdown-item>
                <b-dropdown-item href="#">{{$lang.Common.No}}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <div class="d-flex flex-grow-1">
            <ag-grid-vue class="ag-theme-alpine w-100 h-100"
                         rowSelection="single"
                         :getLocaleText="localeTextFunc"
                         :gridOptions="lpuGridOptions"
                         @gridReady="onGridReady"
                         @rowSelected="onSelectRow"
                         @cellDoubleClicked="onSelect"
                         :rowData="objList"
                         :columnDefs="columnDefs">
            </ag-grid-vue>
          </div>
        </b-card>
      </div>

      <forms class="col-md-7 mb-0 pl-0"
              id="form"
              :title="$lang.PCI.Lpu.Title"
              :showClearButton="true"
              :showSaveButton="data.status === null || data.status === 1"
              v-on:Clear="onClearForm"
              v-on:Save="onSaveForm">
        <div class="form-group row">
          <div class="col-md-12 mb-3">
            <label for="txtDescricao"><small v-if="form.descricao.required">* </small>{{$lang.PCI.Lpu.LabelDescription}}:</label>
            <b-form-input type="text"
                          name="txtDescricao"
                          ref="txtDescricao"
                          :placeholder="$lang.PCI.Lpu.PlaceholderDescription"
                          v-model="form.descricao.value"
                          :required="form.descricao.required"
                          :maxlength="form.descricao.maxlength"
                          :state="form.descricao.state"
                          lazy
                          @update="isChanged = true" />
          </div>
          <div class="col-md-5 mb-3">
            <label for="txtCliente"><small v-if="form.cliente.required">* </small>{{$lang.PCI.Lpu.LabelClient}}:</label>
            <b-form-input type="text"
                          name="txtCliente"
                          ref="txtCliente"
                          v-model="form.cliente.value"
                          :required="form.cliente.required"
                          :maxlength="form.cliente.maxlength"
                          :state="form.cliente.state"
                          lazy
                          @update="isChanged = true" />
          </div>
          <div class="col-md-5 mb-3">
            <label for="txtRegiao"><small v-if="form.regiao.required">* </small>{{$lang.PCI.Lpu.LabelRegion}}:</label>
            <b-form-input type="text"
                          name="txtRegiao"
                          ref="txtRegiao"
                          v-model="form.regiao.value"
                          :required="form.regiao.required"
                          :maxlength="form.regiao.maxlength"
                          :state="form.regiao.state"
                          lazy
                          @update="isChanged = true" />
          </div>
          <div class="col-md-2 mb-3">
            <label for="txtRevisao"><small v-if="form.revisao.required">* </small>{{$lang.PCI.Lpu.LabelRevision}}:</label>
            <b-form-input type="number"
                          name="txtRevisao"
                          ref="txtRevisao"
                          :readonly="true"
                          v-model="form.revisao.value"
                          :required="form.revisao.required"
                          :state="form.revisao.state"
                          lazy
                          @update="isChanged = true" />
          </div>
          <div class="col-md-12 mb-3">
            <label for="txtObservacao"><small v-if="form.observacao.required">* </small>{{$lang.PCI.Lpu.LabelObservation}}:</label>
            <b-form-textarea name="txtObservacao"
                              ref="txtObservacao"
                              v-model="form.observacao.value"
                              :rows="2"
                              :maxRows="10"
                              :required="form.observacao.required"
                              :state="form.observacao.state"
                              lazy />
            <b-button variant="third" class="my-1" v-if="data.id" @click="onSaveObservation">{{ $lang.PCI.Lpu.LabelSaveObservation }}</b-button>
          </div>

          <b-card id="card-custom-columns" class="col-md-12 mb-3 px-0">
            <template #header>
              <i class="fas fa-list"></i> {{$lang.PCI.Lpu.CustomColumns.Title}}
            </template>
            <div id="customColumn"
                  class="row px-0"
                  v-for="(customColumn, index) in form.colunas.value" :key="index">
              <div class="d-flex flex-wrap align-items-center col-md-12">
                <div class="flex-grow-1 px-0">
                  <b-form-input type="text"
                                class="mb-1"
                                v-model="customColumn.rotulo"
                                lazy
                                @update="isChanged = true" />
                </div>
                <div id="actions" class="pl-2 justify-content-end">
                  <b-dropdown href="#"
                              variant="link"
                              toggle-class="text-decoration-none p-0"
                              no-caret
                              tabindex="-1"
                              v-b-tooltip.hover
                              :title="$lang.Common.Tooltip.ButtonDelete">
                    <template #button-content>
                      <i class="fa fa-trash text-danger clickable"></i>
                    </template>
                    <b-dropdown-header><strong>{{$lang.Common.ConfirmDelete}}</strong></b-dropdown-header>
                    <b-dropdown-item href="#" v-on:click="onRemoveCustomColumn(index)">{{$lang.Common.Yes}}</b-dropdown-item>
                    <b-dropdown-item href="#">{{$lang.Common.No}}</b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
            <div class="row px-0">
              <div class="d-flex align-items-center col-md-12">
                <b-form-input type="text"
                              name="txtNewCustomColumn"
                              ref="txtNewCustomColumn"
                              class="flex-grow-1"
                              v-model="customColumnNew"
                              @keydown.enter.native="onNewCustomColumn"
                              :placeholder="$lang.PCI.Lpu.PlaceholderLabel"
                              :maxlength="200"
                              lazy
                              @update="isChanged = true" />
                <span @click="onNewCustomColumn" class="pl-2">
                  <i class="fas fa-plus-circle text-third clickable"></i>
                </span>
              </div>
            </div>
          </b-card>

          <b-card id="card-items" class="col-md-12 mb-3 px-0 mx-0">
            <template #header>
              <b-col>
                <b-row align-h="between">
                  <span>
                    <i class="fas fa-list mr-1"></i> {{$lang.PCI.Lpu.Items.Title}}
                  </span>
                  <div>
                    <span v-if="showExcelIcons && (data.status === null || data.status === 1)"
                          @click="$refs.UploadFile.click()">
                      <input ref="UploadFile" type="file" style="display: none;" @change="onUploadFile" />
                      <i class="far fa-file-excel clickable" v-b-tooltip.hover :title="$lang.PCI.Lpu.TooltipImportItems"></i>
                    </span>
                    <span class="ml-1"
                          v-if="showExcelIcons"
                          @click="onDownloadTemplate">
                      <i class="fas fa-file-download clickable" v-b-tooltip.hover :title="$lang.PCI.Lpu.TooltipExportTemplate"></i>
                    </span>
                    <span class="ml-1"
                          v-if="data.id"
                          @click="onSortSequence">
                      <i class="fas fa-sort-amount-down-alt clickable" v-b-tooltip.hover :title="$lang.PCI.Lpu.TooltipOrder"></i>
                    </span>
                  </div>
                </b-row>
              </b-col>
            </template>

            <draggable tag="div"
                       id="item"
                       class="col-md-12 p-0"
                       ghost-class="sortable-ghost"
                       @end="onMoveItem"
                       :animation="100"
                       handle=".handle"
                       v-model="form.itens.value"
                       >
              <div v-for="(item, index) in form.itens.value" :key="index" class="d-flex flex-wrap align-items-center col px-0">
                <div class="pl-0 pr-1 mb-1 handle">
                  <i class="fa fa-align-justify" style="cursor: grab;"></i>
                </div>
                <div class="px-0 mb-1 mr-1" style="width: 5rem;">
                  <b-form-input type="text"
                                ref="txtSequence"
                                v-model="item.sequencia"
                                lazy
                                @update="isChanged = true" />
                </div>
                <div class="d-flex align-items-center px-0 mb-1 mr-1" style="width: 5rem;" v-if="item.cor">
                  <i class="fas fa-times text-danger mr-1 clickable" @click="unsetColor(item)"></i>
                  <b-form-input type="color" ref="txtColor" v-model="item.cor" @update="isChanged = true"></b-form-input>
                </div>
                <div class="pl-1 pr-0 mb-1 mr-1" v-if="item.cor">
                  <b-form-checkbox v-model="item.negrito">{{'Negrito'}}</b-form-checkbox>
                </div>
                <div class="pl-1 pr-0 mb-1 mr-1" v-if="item.cor">
                  <b-form-checkbox v-model="item.fonteClara">{{'Fonte Clara'}}</b-form-checkbox>
                </div>
                <div class="flex-grow-1 pl-1 pr-0 mb-1">
                  <b-form-input type="text"
                                :style="{'background-color': (item.cor || '#ffffff'), 'font-weight': (item.cor && item.negrito ? 'bold' : 'normal'), 'color': (item.cor && item.fonteClara ? '#ffffff' : '#000000')}"
                                v-model="item.descricao" />
                </div>
                <div class="pl-1 pr-0 mb-1">
                  <b-form-select type="text"
                                 :options="tipoItemOptions"
                                 v-model="item.tipoItem"
                                 lazy
                                 @update="isChanged = true" />
                </div>
                <div class="pl-1 pr-0 mb-1">
                  <b-form-select type="text"
                                 :options="tipoAgrupamentoOptions"
                                 v-model="item.tipoAgrupamento"
                                 lazy
                                 @update="isChanged = true" />
                </div>
                <div class="pl-1 pr-0 mb-1" v-if="item.tipoAgrupamento === 0">
                  <b-form-input type="number"
                      name="txtValor"
                      ref="txtValor"
                      style="width: 8rem;"
                      v-model="item.lpuItemDetalhe.valor"
                      :required="true"
                      lazy
                      @update="isChanged = true" />
                </div>
                <div id="actions" class="pl-2 justify-content-end align-items-center">
                  <span class="mr-2" v-if="item.tipoAgrupamento === 0" @click="onEditItemDetail(index)">
                    <i class="fas fa-pen text-third clickable"></i>
                  </span>
                  <b-dropdown href="#"
                              variant="link"
                              toggle-class="text-decoration-none p-0 mr-2"
                              no-caret
                              tabindex="-1"
                              v-b-tooltip.hover
                              :title="$lang.Common.Tooltip.ButtonDelete">
                    <template #button-content>
                      <i class="fa fa-trash text-danger clickable"></i>
                    </template>
                    <b-dropdown-header><strong>{{$lang.Common.ConfirmDelete}}</strong></b-dropdown-header>
                    <b-dropdown-item href="#" v-on:click="onRemoveItem(index)">{{$lang.Common.Yes}}</b-dropdown-item>
                    <b-dropdown-item href="#">{{$lang.Common.No}}</b-dropdown-item>
                  </b-dropdown>
                  <span v-if="!item.cor" v-b-tooltip.hover :title="'Adicionar cor'" @click="setInitialColor(item)">
                    <i class="fas fa-palette clickable text-primary"></i>
                  </span>
                </div>

                <AddItemDetail ref="addItemDetail" @ok="onOkItemDetail" @change="isChanged = true" />
              </div>
            </draggable>

            <div v-if="showAddItemDetailIndex < 0" class="d-flex align-items-center col-md-12 px-0">
              <b-form-input type="text"
                            name="txtItemNovo"
                            ref="txtItemNovo"
                            class="flex-grow-1"
                            v-model="itemNew"
                            @keydown.enter.native="onNewItem"
                            :placeholder="$lang.PCI.Lpu.PlaceholderDescription"
                            :maxlength="200"
                            lazy
                            @update="isChanged = true" />
              <span @click="onNewItem" class="pl-2">
                <i class="fas fa-plus-circle text-third clickable"></i>
              </span>
            </div>
          </b-card>
        </div>
      </forms>
    </b-row>
    <!-- </b-card> -->
  </b-container>
</template>

<script>
import Lpu from './lpu.js'
export default Lpu
</script>

<style scoped>
#actions {
  display: none;
}

div#item > .col:hover > #actions {
  display: flex;
}

div#customColumn:hover div#actions {
  display: flex;
}

#form >>> div.card {
  margin-bottom: 0;
}

div.card-body {
  display: flex;
  flex-direction: column;
}

#card-items > .card-body {
  flex-direction: row;
  flex-wrap: wrap;
}

i {
  font-size: 1rem;
}

i.clickable {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/lpu/lpu.vue